import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Crown, Mail, Lock, ArrowRight, Shield } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { authService } from '../../services/authService';
import { showError } from '../../utils/alert';

const Login = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  const handleMerchantLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await authService.login(email, password);
      if (email === 'scrachcard@gmail.com') {
        navigate('/super-admin/dashboard');
      } else {
        const shop = await authService.getCurrentShop();
        if (shop?.endDate) {
          const today = new Date();
          const end = new Date(shop.endDate);
          today.setHours(0, 0, 0, 0);
          end.setHours(0, 0, 0, 0);
          if (today.getTime() > end.getTime()) {
            await authService.logout();
            showError('Access Denied', 'Your subscription has expired. Please contact admin.');
            return;
          }
        }
        navigate('/admin/dashboard');
      }
    } catch (error) {
      showError('Access Denied', error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-6 bg-[#fdfdfd] relative overflow-hidden">
      <div className="absolute inset-0 luxury-grid-bg pointer-events-none" />
      <div className="absolute top-[-10%] left-[-10%] w-[500px] h-[500px] bg-[#d4af37]/5 rounded-full blur-[120px] animate-pulse" />
      <div className="absolute bottom-[-10%] right-[-10%] w-[500px] h-[500px] bg-black/[0.02] rounded-full blur-[120px]" />

      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="luxury-card w-full max-w-lg p-12 relative z-10"
      >
        <div className="text-center mb-12">
          <motion.div
            initial={{ scale: 0.8, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            className="w-24 h-24 rounded-[2.5rem] bg-black flex items-center justify-center text-[#d4af37] mx-auto mb-8 shadow-2xl relative"
          >
            <div className="absolute inset-0 bg-[#d4af37]/10 blur-xl rounded-full animate-pulse" />
            <Shield size={32} className="relative" />
          </motion.div>

          <h1 className="text-4xl font-serif text-black mb-3">Merchant Hub</h1>
          <p className="text-[#999] text-[9px] font-black uppercase tracking-[0.5em]">
            Authenticity Protocol v4.0
          </p>
        </div>

        <form className="space-y-8" onSubmit={handleMerchantLogin}>
          <div className="space-y-2 group">
            <label className="text-[10px] font-bold text-[#999] uppercase tracking-[0.2em] ml-4">Credential Identity</label>
            <div className="relative">
              <Mail className="absolute left-6 top-1/2 -translate-y-1/2 text-[#ccc]" size={18} />
              <input 
                type="email" required
                placeholder="Business Email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full bg-black/[0.02] border border-black/[0.05] rounded-3xl py-4 pl-16 pr-8 text-sm focus:outline-none focus:border-black/20 transition-all"
              />
            </div>
          </div>
          <div className="space-y-2 group">
            <label className="text-[10px] font-bold text-[#999] uppercase tracking-[0.2em] ml-4">Vault Key</label>
            <div className="relative">
              <Lock className="absolute left-6 top-1/2 -translate-y-1/2 text-[#ccc]" size={18} />
              <input 
                type="password" required
                placeholder="Enter Secret Key"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full bg-black/[0.02] border border-black/[0.05] rounded-3xl py-4 pl-16 pr-8 text-sm focus:outline-none focus:border-black/20 transition-all"
              />
            </div>
          </div>
          <button disabled={loading} className="luxury-button w-full flex items-center justify-center gap-3 !py-5">
            {loading ? 'Decrypting...' : 'Establish Connection'} <ArrowRight size={18} />
          </button>
        </form>

        <div className="mt-12 text-center">
          <p className="text-[9px] text-black/20 uppercase tracking-widest">Secured by Digi Sahyadri Infrastructure</p>
        </div>
      </motion.div>
    </div>
  );
};

export default Login;
